export default __webpack_public_path__ + "static/media/base-report19.d3ae7d61.png";